import './assets/colors-production.scss';
import './assets/font.scss';
import './assets/others.scss';

const productionGlobalStyles = () => {
    return 'production-mode';
};

export default productionGlobalStyles;
